var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("LfHeaderTitleComponent", {
        staticClass: "header-title",
        attrs: { title: _vm.texts.headerTitle },
      }),
      _vm.totals && _vm.totals.length
        ? _c("LfTotalsComponent", { attrs: { items: _vm.totals } })
        : _vm._e(),
      _vm.renderGrid && !_vm.showSpinnerLayer
        ? _c("GridTable", {
            ref: "grid",
            attrs: {
              itemsData: _vm.isPortalUser ? _vm.listItems : _vm.serverSideData,
              gridConfiguration: _vm.gridConfiguration,
              toolbarOptions: _vm.toolbarOptionsCustom,
              contextMenuItems: _vm.isPortalUser
                ? [_vm.printButton]
                : _vm.invoiceContextMenuItems,
              listName: _vm.listConfiguration["Alias"],
              context: _vm.context,
              archivedFilter: _vm.archivedSelectedOption,
              disabledGridCellClicked: _vm.getDisableGridProperty,
              commandClick: _vm.onCommandClick,
              excelExportedFileName: "hojas de encargo",
              useServerPagination: _vm.useServerPagination,
              itemsDataExport: _vm.serverSideExportData,
            },
            on: {
              contextMenuClicked: _vm.onContextMenuClicked,
              gridTableFilter: _vm.onGridTableFilter,
              toolbarClicked: _vm.onToolbarClicked,
              customToolbarContextMenuClick:
                _vm.onCustomToolbarContextMenuClick,
              gridActionChange: _vm.gridActionChange,
              gridExportData: _vm.gridExportData,
            },
          })
        : _vm._e(),
      _c("ejs-contextmenu", {
        staticClass: "context-menu-component e-contextmenu-archived",
        attrs: {
          id: _vm.idContextMenu,
          items: _vm.invoicesArchivedContextMenuItemsParsed,
          select: _vm.onInvoicesArchivedClick,
        },
      }),
      _c("TemplateSelectorComponent", {
        attrs: {
          showDialog: _vm.showTemplateDialog,
          idEntityType: _vm.idEntityType,
        },
        on: {
          closeTemplateDialog: _vm.closeTemplateDialog,
          generateTemplateDialog: _vm.generateTemplateDialog,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }